import { render } from "./syllabus-list.vue?vue&type=template&id=491477b4&scoped=true"
import script from "./syllabus-list.vue?vue&type=script&lang=js"
export * from "./syllabus-list.vue?vue&type=script&lang=js"

import "./syllabus-list.vue?vue&type=style&index=0&id=491477b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491477b4"]])

export default __exports__